import React, { ReactElement } from 'react';

import { Box, Typography } from '@mui/material';
import Icon, { SizeVariant } from '@apigrowfinance/pbolt-icon';

export type MapPanelErrorProps = {
    icon: ReactElement;
    title: React.ReactNode;
    description: React.ReactNode;
};

const MapPanelError = ({ icon, title, description }: MapPanelErrorProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
            }}>
            <Box sx={{ mb: 2 }}>
                <Icon
                    sizeVariant={SizeVariant.Medium}
                    avatarProps={{
                        sx: {
                            color: 'text.secondary',
                        },
                    }}>
                    {icon}
                </Icon>
            </Box>
            <Typography
                variant="overline"
                sx={{
                    fontSize: (theme) => theme.typography.overline.fontSize,
                    mb: 1,
                }}>
                {title}
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    fontSize: (theme) => theme.typography.body2.fontSize,
                }}>
                {description}
            </Typography>
        </Box>
    );
};
export default MapPanelError;
